import { createSelector } from 'reselect'

const formatVendor = ({ category, id, image, ...vendor }, index) => ({
  ...vendor,
  id: id + index,
  image: image || category.image,
})

const sortAliasesByName = (aliasA, aliasB) => {
  return aliasA.value?.name
    ?.replace(/\W+/g, '')
    ?.localeCompare(aliasB.value?.name?.replace(/\W+/g, ''))
}

const getVendorAliases = ({ vendors }) => vendors.vendorAliases
const getVendors = ({ vendors }) => ({
  next: vendors.next,
  previous: vendors.previous,
  vendors: vendors.vendors,
})
const getFetchingVendors = ({ vendors }) => vendors.fetchingVendors
const getUpdatingVendor = ({ vendor }) => {
  return (
    vendor.addingAlias ||
    vendor.addingTag ||
    vendor.changingAlias ||
    vendor.changingTag ||
    vendor.deletingAlias ||
    vendor.deletingTag
  )
}

export const vendorsSelectors = {
  getVendorAliases: createSelector([getVendorAliases], (vendorAliases) => {
    return [...vendorAliases].sort(sortAliasesByName)
  }),
  getVendors: createSelector([getVendors], ({ next, previous, vendors }) => {
    return { next, previous, vendors: vendors.map(formatVendor) }
  }),
  getFetchingVendors: createSelector(
    [getFetchingVendors],
    (fetchingExpenseFilters) => fetchingExpenseFilters,
  ),
  getUpdatingVendor: createSelector(getUpdatingVendor, (updatingVendor) => updatingVendor),
}
